/// <reference path="../../common/guid.ts" />
var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var ViewModels;
        (function (ViewModels) {
            var BaseViewModel = /** @class */ (function () {
                function BaseViewModel($scope) {
                    this.$scope = $scope;
                    this.isBusy = false;
                    this.tabModuleID = null;
                    this.portalID = null;
                    this.contentAvailable = false;
                    this.needsRebind = false;
                    var self = this;
                    this.id = EnvNgApp.Common.Guid.newGuid();
                    if ($scope) {
                        $scope.$on(EnvNgApp.Constants.AppEvents.translatedDataChanged, function () {
                            var injector = EnvNgApp.Application.getInstance().getInjector();
                            if (injector) {
                                injector.invoke([
                                    EnvNgApp.Constants.AngularModuleNames.Timeout, function ($timeout) {
                                        $timeout(function () {
                                            self.needsRebind = true;
                                        }, 300);
                                    }
                                ]);
                            }
                        });
                    }
                }
                BaseViewModel.prototype.getIsolatedScope = function (scope) {
                    if (scope) {
                        return scope["vm"];
                    }
                    return undefined;
                };
                BaseViewModel.prototype.setScopeInputs = function (scopeInputs) {
                    if (scopeInputs) {
                        for (var k in scopeInputs) {
                            this[k] = scopeInputs[k];
                        }
                    }
                };
                BaseViewModel.prototype.ready = function () {
                    this.contentAvailable = true;
                };
                BaseViewModel.prototype.getTemplate = function (selector) {
                    return $(selector).html();
                };
                BaseViewModel.$inject = [
                    EnvNgApp.Constants.AngularModuleNames.Scope
                ];
                return BaseViewModel;
            }());
            ViewModels.BaseViewModel = BaseViewModel;
        })(ViewModels = Core.ViewModels || (Core.ViewModels = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=baseviewmodel.js.map